function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 14,
  fill: "#FFC2C2"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99967 18.6667C9.99967 19.4 10.5997 20 11.333 20H16.6663C17.3997 20 17.9997 19.4 17.9997 18.6667V10.6667H9.99967V18.6667ZM11.333 12H16.6663V18.6667H11.333V12ZM16.333 8.66667L15.6663 8H12.333L11.6663 8.66667H9.33301V10H18.6663V8.66667H16.333Z",
  fill: "#BF1F1F"
});
function SvgTrashIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconTable);
export default __webpack_public_path__ + "static/media/trash-icon-table.dfac4e3d.svg";
export { ForwardRef as ReactComponent };